import {proxy} from "valtio";

import {ATTACH_EVENTS, LocationSearchClass} from "./location-search.model";

/**
 * Extension of LocationSearchClass that preserves the last selected slug
 * when the input is cleared. This ensures that clearing the location field
 * does not immediately drop the location filter from the search query —
 * the previous slug is kept until a new location is explicitly selected.
 */
class LocationSearchWithFallbackClass extends LocationSearchClass {
    private lastSlug: string = "";

    override clear(silent = false): void {
        if (this.slug) {
            this.lastSlug = this.slug;
        }
        super.clear(silent);
    }

    clearWithOutLastSlug(): void {
        this.lastSlug = "";
        this.input.clear();
        this.selectedOption = null;
        this.error = null;
        this.pendingSlug = null;
    }

    protected override afterClear(silent: boolean): void {
        this.isOpen = !silent;
    }

    override getQueryParamSlug(paramName = "location"): string {
        const current = super.getQueryParamSlug(paramName);
        if (current) {
            this.lastSlug = this.slug;
            return current;
        }
        if (this.lastSlug) {
            return `${paramName}=${encodeURIComponent(this.lastSlug)}`;
        }
        return "";
    }
}

export type LocationSearchWithFallbackInstance = LocationSearchWithFallbackClass;

export function LocationSearchWithFallback(): LocationSearchWithFallbackInstance {
    const instance = proxy(new LocationSearchWithFallbackClass());
    instance[ATTACH_EVENTS]();
    return instance;
}
